import { SvgIcon } from '@material-ui/core';
import React from 'react';

export const UsersIsometricIcon = () => (
  <SvgIcon
    width="42"
    height="83"
    style={{ width: 'auto', height: 'auto', fill: 'none' }}
    viewBox="0 0 42 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.0366 71.0495L21.996 82.0399C21.7079 82.2076 21.332 82.2876 20.9562 82.2876C20.5799 82.2876 20.2082 82.2076 19.9204 82.0432L0.875395 71.0495C0.587279 70.8813 0.443237 70.6655 0.443237 70.4492C0.443237 70.2292 0.586871 70.0137 0.875395 69.8493L3.89898 68.1059L19.9164 58.8552C20.4877 58.5234 21.4202 58.5234 21.996 58.8552L41.0366 69.8493C41.6087 70.1774 41.6087 70.7173 41.0366 71.0495Z"
      fill="#DCEEFF"
    />
    <path
      d="M20.9562 77.9519V82.2875C20.5799 82.2875 20.2082 82.2076 19.9204 82.0431L0.875395 71.0494C0.587279 70.8813 0.443237 70.6654 0.443237 70.4491V66.6938C0.443237 66.5379 0.519535 66.3783 0.671347 66.2424L3.89898 68.1058L20.9562 77.9519Z"
      fill="#A5CBFA"
    />
    <path
      d="M20.9563 77.9519V82.2875C21.3322 82.2875 21.7039 82.2076 21.9921 82.0431L41.0367 71.0494C41.3248 70.8813 41.4689 70.6654 41.4689 70.4491V66.6938C41.4689 66.5379 41.3925 66.3783 41.2407 66.2424L38.0135 68.1058L20.9563 77.9519Z"
      fill="#C8E2FF"
    />
    <path
      d="M41.0366 67.2941L21.996 78.2882C21.7079 78.456 21.332 78.5364 20.9562 78.5364C20.5799 78.5364 20.2041 78.4564 19.9164 78.2882L0.875395 67.2941C0.587279 67.1301 0.443237 66.9138 0.443237 66.6938C0.443237 66.5379 0.519535 66.3784 0.671347 66.2425C0.727664 66.1902 0.795408 66.138 0.875395 66.0943L19.9164 55.1039C20.4877 54.7717 21.4202 54.7717 21.996 55.1039L41.0366 66.0943C41.6087 66.4261 41.6087 66.966 41.0366 67.2941Z"
      fill="#DCEEFF"
    />
    <path
      d="M20.9546 55.2633C21.2725 55.2633 21.5777 55.3339 21.792 55.4576L40.8317 66.4476C40.9986 66.5443 41.0578 66.6423 41.0578 66.6961C41.0574 66.7496 40.9986 66.8455 40.8325 66.941L21.7903 77.9359C21.5806 78.0583 21.2765 78.1285 20.9562 78.1285C20.6354 78.1285 20.3314 78.0584 20.1204 77.9351L1.0774 66.9398C0.939872 66.8618 0.851334 66.7651 0.851334 66.6941C0.851334 66.6533 0.886002 66.5982 0.948849 66.5415C0.98721 66.506 1.02844 66.4758 1.07904 66.448L20.1208 55.4572C20.3334 55.3339 20.6371 55.2633 20.9546 55.2633ZM20.9546 54.8552C20.5779 54.8552 20.202 54.9381 19.9164 55.1037L0.875395 66.0942C0.795408 66.1379 0.727664 66.1901 0.671347 66.2423C0.519535 66.3782 0.443237 66.5382 0.443237 66.6937C0.443237 66.9137 0.586871 67.1295 0.875395 67.294L19.9164 78.2877C20.2041 78.4558 20.5799 78.5358 20.9562 78.5358C21.332 78.5358 21.7079 78.4558 21.996 78.2877L41.0366 67.294C41.6083 66.9659 41.6083 66.426 41.0366 66.0942L21.996 55.1037C21.7079 54.9381 21.3312 54.8552 20.9546 54.8552Z"
      fill="white"
    />
    <path
      d="M20.2626 57.716L5.40257 66.2954C5.01978 66.5162 5.01978 66.8745 5.40257 67.0953L20.263 75.6747C20.6458 75.8955 21.2657 75.8955 21.6481 75.6747L36.5081 67.0953C36.8909 66.8745 36.8909 66.5162 36.5081 66.2954L21.6481 57.716C21.2657 57.4952 20.645 57.4952 20.2626 57.716Z"
      fill="#344593"
    />
    <path
      d="M36.5084 66.2955L21.6484 57.7161C21.4566 57.6055 21.206 57.5508 20.9554 57.5508V58.2547L36.3888 67.1647L36.5084 67.0957C36.8908 66.8746 36.8908 66.5163 36.5084 66.2955Z"
      fill="#1E3779"
    />
    <path
      d="M20.9555 57.5508C20.705 57.5508 20.454 57.6059 20.2626 57.7161L5.40257 66.2955C5.01978 66.5163 5.01978 66.8746 5.40257 67.0953L5.52213 67.1647L20.9555 58.2543V57.5508Z"
      fill="#031F60"
    />
    <path
      d="M22.5801 80.5461L23.7403 79.876V78.5363L22.5801 79.2059V80.5461Z"
      fill="#E73555"
    />
    <path
      d="M24.2046 79.6863L25.3652 79.0162V77.676L24.2046 78.3465V79.6863Z"
      fill="#0662DD"
    />
    <path
      d="M16.1819 51.4701L26.47 42.0912L28.6807 53.4183"
      stroke="#344593"
      strokeWidth="0.924908"
      strokeMiterlimit="10"
    />
    <path
      d="M13.5131 51.4701C13.5131 49.9961 14.708 48.8011 16.182 48.8011C17.6556 48.8011 18.8509 49.9961 18.8509 51.4701C18.8509 52.9437 17.6556 54.1391 16.182 54.1391C14.708 54.1391 13.5131 52.9437 13.5131 51.4701Z"
      fill="url(#paint0_linear_5106_35687)"
    />
    <path
      d="M25.0308 42.0912C25.0308 41.2962 25.6752 40.6519 26.4701 40.6519C27.2651 40.6519 27.9095 41.2962 27.9095 42.0912C27.9095 42.8858 27.2651 43.5302 26.4701 43.5302C25.6752 43.5302 25.0308 42.8858 25.0308 42.0912Z"
      fill="url(#paint1_linear_5106_35687)"
    />
    <path
      d="M26.8771 53.4183C26.8771 52.4221 27.6847 51.6145 28.6809 51.6145C29.677 51.6145 30.4847 52.4217 30.4847 53.4183C30.4847 54.4149 29.677 55.2221 28.6809 55.2221C27.6847 55.2217 26.8771 54.4144 26.8771 53.4183Z"
      fill="url(#paint2_linear_5106_35687)"
    />
    <path
      opacity="0.3"
      d="M20.9563 28.3278L0.443726 16.4897V67.0463L20.9546 78.8885"
      fill="#8FAAE9"
    />
    <path
      opacity="0.2"
      d="M20.9546 78.8885L41.4659 67.0463L41.4688 16.4897L20.9562 28.3278"
      fill="#8FAAE9"
    />
    <path
      d="M41.0366 17.0897L21.996 28.0801C21.7079 28.2482 21.332 28.3278 20.9562 28.3278C20.5799 28.3278 20.2082 28.2482 19.9204 28.0838L0.875395 17.0897C0.587279 16.9219 0.443237 16.7061 0.443237 16.4898C0.443237 16.2698 0.586871 16.0539 0.875395 15.8899L3.89898 14.1461L19.9164 4.89575C20.4877 4.56356 21.4202 4.56356 21.996 4.89575L41.0366 15.8899C41.6087 16.218 41.6087 16.7579 41.0366 17.0897Z"
      fill="#DCEEFF"
    />
    <path
      d="M20.9562 23.9926V28.3278C20.5799 28.3278 20.2082 28.2483 19.9204 28.0838L0.875395 17.0897C0.587279 16.9219 0.443237 16.7061 0.443237 16.4898V12.7345C0.443237 12.5786 0.519535 12.4186 0.671347 12.2827L3.89898 14.1461L20.9562 23.9926Z"
      fill="#A5CBFA"
    />
    <path
      d="M20.9563 23.9926V28.3278C21.3322 28.3278 21.7039 28.2483 21.9921 28.0838L41.0367 17.0897C41.3248 16.9219 41.4689 16.7061 41.4689 16.4898V12.7345C41.4689 12.5786 41.3925 12.4186 41.2407 12.2827L38.0135 14.1461L20.9563 23.9926Z"
      fill="#C8E2FF"
    />
    <path
      d="M41.0366 13.3345L21.996 24.3287C21.7079 24.4968 21.332 24.5764 20.9562 24.5764C20.5799 24.5764 20.2041 24.4968 19.9164 24.3287L0.875395 13.3345C0.587279 13.1709 0.443237 12.9546 0.443237 12.7346C0.443237 12.5788 0.519535 12.4188 0.671347 12.2829C0.727664 12.2311 0.795408 12.1788 0.875395 12.1352L19.9164 1.14471C20.4877 0.812928 21.4202 0.812928 21.996 1.14471L41.0366 12.1352C41.6087 12.4669 41.6087 13.0064 41.0366 13.3345Z"
      fill="#DCEEFF"
    />
    <path
      d="M20.9546 1.30373C21.2725 1.30373 21.5777 1.37473 21.792 1.49838L40.8317 12.488C40.9986 12.5847 41.0578 12.6827 41.0578 12.7365C41.0574 12.7904 40.9986 12.8863 40.8325 12.9814L21.7903 23.9767C21.5806 24.0988 21.2765 24.1689 20.9562 24.1689C20.6354 24.1689 20.3314 24.0988 20.1204 23.9755L1.0774 12.9802C0.939872 12.9026 0.851334 12.8059 0.851334 12.7349C0.851334 12.6937 0.885594 12.6386 0.948849 12.5819C0.98721 12.5464 1.02844 12.5166 1.07904 12.4888L20.1208 1.49799C20.3334 1.37433 20.6371 1.30373 20.9546 1.30373ZM20.9546 0.89563C20.5779 0.89563 20.202 0.978888 19.9164 1.14458L0.875395 12.135C0.795408 12.1787 0.727664 12.2309 0.671347 12.2827C0.519535 12.4186 0.443237 12.579 0.443237 12.7345C0.443237 12.9545 0.586871 13.1704 0.875395 13.3344L19.9164 24.3285C20.2041 24.4967 20.5799 24.5762 20.9562 24.5762C21.332 24.5762 21.7079 24.4967 21.996 24.3285L41.0366 13.3344C41.6083 13.0063 41.6083 12.4668 41.0366 12.135L21.996 1.14458C21.7079 0.978888 21.3312 0.89563 20.9546 0.89563Z"
      fill="white"
    />
    <path
      d="M20.2626 3.75677L5.40257 12.3362C5.01978 12.557 5.01978 12.9153 5.40257 13.136L20.263 21.7154C20.6458 21.9362 21.2657 21.9362 21.6481 21.7154L36.5081 13.136C36.8909 12.9153 36.8909 12.557 36.5081 12.3362L21.6481 3.75677C21.2657 3.53599 20.645 3.53599 20.2626 3.75677Z"
      fill="#344593"
    />
    <path
      d="M36.5084 12.3366L21.6484 3.75723C21.4566 3.64664 21.206 3.59155 20.9554 3.59155V4.29551L36.3888 13.2059L36.5084 13.1369C36.8908 12.9157 36.8908 12.5574 36.5084 12.3366Z"
      fill="#1E3779"
    />
    <path
      d="M20.9555 3.59106C20.705 3.59106 20.454 3.64657 20.2626 3.75675L5.40257 12.3362C5.01978 12.5569 5.01978 12.9153 5.40257 13.136L5.52213 13.205L20.9555 4.29462V3.59106Z"
      fill="#031F60"
    />
    <path
      opacity="0.3"
      d="M19.9205 28.0839C19.9981 28.1263 20.078 28.1634 20.1601 28.1953C20.078 28.1639 19.9981 28.1267 19.9205 28.0839Z"
      fill="#8FAAE9"
    />
    <path
      opacity="0.3"
      d="M20.6613 28.3145C20.6669 28.3153 20.672 28.317 20.6781 28.3175C20.672 28.317 20.6664 28.3153 20.6613 28.3145Z"
      fill="#8FAAE9"
    />
    <path
      opacity="0.3"
      d="M20.9353 75.8383C20.7112 75.835 20.4872 75.7824 20.2635 75.6763C20.4876 75.7824 20.7116 75.835 20.9353 75.8383Z"
      fill="#8FAAE9"
    />
    <path
      opacity="0.3"
      d="M21.996 28.08C21.6957 28.2714 21.3434 28.3412 20.9562 28.3277C20.95 28.3281 20.9452 28.3269 20.9395 28.3273C20.9448 28.3269 20.9492 28.3277 20.9545 28.3277V75.8404C21.1855 75.8404 21.4169 75.7852 21.6479 75.6751L36.3883 67.1642C36.6626 67.0132 36.7948 66.8798 36.7948 66.6957V19.5386L21.996 28.08Z"
      fill="#8FAAE9"
    />
    <path
      opacity="0.5"
      d="M20.9552 75.8406C20.9484 75.8406 20.9421 75.8385 20.9353 75.8385C20.9421 75.8385 20.9488 75.8406 20.9552 75.8406Z"
      fill="#8FAAE9"
    />
    <path
      opacity="0.5"
      d="M20.4121 28.2727C20.4929 28.2919 20.5758 28.305 20.6606 28.3143C20.5762 28.305 20.4929 28.2919 20.4121 28.2727Z"
      fill="#8FAAE9"
    />
    <path
      opacity="0.5"
      d="M20.677 28.3173C20.7627 28.3258 20.8504 28.3287 20.9398 28.3275C20.85 28.3287 20.7627 28.3258 20.677 28.3173Z"
      fill="#8FAAE9"
    />
    <path
      opacity="0.5"
      d="M20.9394 28.3274C20.85 28.3286 20.7623 28.3258 20.6766 28.3172C20.6709 28.3168 20.666 28.3152 20.6607 28.3144C20.5758 28.305 20.4929 28.2919 20.4121 28.2727C20.3587 28.2605 20.3077 28.2417 20.2558 28.225C20.224 28.2148 20.191 28.2074 20.1599 28.1956C20.0779 28.1638 19.9979 28.1266 19.9204 28.0842L5.11548 19.5378V66.6954C5.12242 66.8652 5.22771 66.9945 5.40237 67.0953L20.2636 75.676C20.4877 75.7825 20.7117 75.8351 20.9353 75.838C20.9419 75.838 20.948 75.84 20.9545 75.84V28.3278C20.9496 28.3278 20.9447 28.327 20.9394 28.3274Z"
      fill="#8FAAE9"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5106_35687"
        x1="14.4453"
        y1="49.7334"
        x2="17.9972"
        y2="53.2853"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#91F1E6" />
        <stop offset="1" stopColor="#0662DD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5106_35687"
        x1="25.5335"
        y1="41.1543"
        x2="27.4491"
        y2="43.0699"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#91F1E6" />
        <stop offset="1" stopColor="#0662DD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5106_35687"
        x1="27.5071"
        y1="52.2444"
        x2="29.9077"
        y2="54.645"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#91F1E6" />
        <stop offset="1" stopColor="#0662DD" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
